module.exports = __webpack_public_path__ + "static/img/logoonechat_full-white.78b318a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/image/logoonechat_full-white.png
// module id = 76
// module chunks = 0